import React from "react";
import { WbSunny as Sun, AutoAwesome as Sparkles } from "@mui/icons-material";
import styles from "./FeatureOptionsPanel.module.css";

function FeatureOptionsPanel({ feature, options, setOption }) {
  switch (feature) {
    case "shadow":
      return (
        <div className={styles.group}>
          <div>
            <label className={styles.label}>Background Color</label>
            <div className={styles.colorRow}>
              <input
                type="color"
                value={options.backgroundColor ?? "#ffffff"}
                onChange={(e) => setOption("backgroundColor", e.target.value)}
                className={styles.colorSwatch}
              />
              <input
                type="text"
                value={options.backgroundColor ?? "#ffffff"}
                onChange={(e) => setOption("backgroundColor", e.target.value)}
                className={styles.inputFlex}
                placeholder="#ffffff"
              />
            </div>
          </div>
          <p className={styles.hint}>
            Output size is set in the <strong>custom size</strong> bar at the top.
          </p>
          <div>
            <label className={styles.label}>
              Padding:{" "}
              <span className={styles.paddingValue}>{options.padding ?? "0.1"}</span>
            </label>
            <input
              type="range"
              min="0"
              max="0.5"
              step="0.01"
              value={options.padding ?? "0.1"}
              onChange={(e) => setOption("padding", e.target.value)}
              className={styles.range}
            />
            <div className={styles.rangeLabels}>
              <span>0</span>
              <span>0.5</span>
            </div>
          </div>
        </div>
      );

    case "aiBackground":
      return (
        <div className={styles.group}>
          <div>
            <label className={styles.label}>
              Background Prompt
              <span className={styles.labelMuted}>
                ({(options.prompt ?? "").length}/500)
              </span>
            </label>
            <textarea
              value={options.prompt ?? ""}
              onChange={(e) => setOption("prompt", e.target.value.slice(0, 500))}
              rows={4}
              placeholder="Describe the background you want…"
              className={styles.textarea}
            />
          </div>
        </div>
      );

    case "expand":
      return (
        <div className={styles.group}>
          <div>
            <label className={styles.label}>Width (required)</label>
            <input
              type="number"
              min="1"
              placeholder="e.g. 1920"
              value={options.expandWidth ?? ""}
              onChange={(e) => setOption("expandWidth", e.target.value)}
              className={styles.input}
            />
          </div>
          <div>
            <label className={styles.label}>Height (required)</label>
            <input
              type="number"
              min="1"
              placeholder="e.g. 1080"
              value={options.expandHeight ?? ""}
              onChange={(e) => setOption("expandHeight", e.target.value)}
              className={styles.input}
            />
          </div>
          <p className={styles.hint}>
            Set the output width and height for the expanded image (e.g. 1920×1080).
          </p>
        </div>
      );

    case "relight":
      return (
        <div className={styles.infoCard}>
          <Sun sx={{ fontSize: 32, color: "var(--aig-dark)", display: "block", margin: "0 auto 8px" }} />
          <p className={styles.infoTitle}>AI Automatic Relighting</p>
          <p className={styles.infoSub}>
            No additional options required. Click Apply to relight the image.
          </p>
        </div>
      );

    case "beautify":
      return (
        <div className={styles.infoCard}>
          <Sparkles sx={{ fontSize: 32, color: "var(--aig-dark)", display: "block", margin: "0 auto 8px" }} />
          <p className={styles.infoTitle}>AI Auto Beautification</p>
          <p className={styles.infoSub}>
            No additional options required. Click Apply to enhance the image.
          </p>
        </div>
      );

    default:
      return null;
  }
}

export default React.memo(FeatureOptionsPanel);
